import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';

import { messages as countryNameMessages } from '../../../../country-names.messages';
import { useSortedTranslatedCountries } from '../../../../../hooks/use-sorted-translated-countries';

const messages = defineMessages({
  dropdownPlaceholder: {
    description: 'country.dropdownPlaceholder',
    defaultMessage: 'Select a country',
    id: 'RKyIGS',
  },
});

export const ShipToCountry = ({ selectedCountryCode, onChange, disabled = false }) => {
  const intl = useIntl();
  const sortedTranslatedCountryObjs = useSortedTranslatedCountries();

  const selectedCountry = sortedTranslatedCountryObjs.find(({ code }) => code === selectedCountryCode);
  const dropdownLabelMessage = countryNameMessages[selectedCountry?.code] || messages.dropdownPlaceholder;

  return (
    <DropdownMenu disabled={disabled} dropdownMenuShouldHaveWidthOfButton fullWidth value={selectedCountryCode} variant='form'>
      <DropdownMenuToggler>{intl.formatMessage(dropdownLabelMessage)}</DropdownMenuToggler>
      {sortedTranslatedCountryObjs.map(({ code, label }) => {
        return (
          <DropdownMenuItem key={code} onClick={() => onChange(code)} selected={selectedCountryCode === code}>
            {label}
          </DropdownMenuItem>
        );
      })}
    </DropdownMenu>
  );
};

ShipToCountry.propTypes = {
  selectedCountryCode: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
